import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Percent } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";

export function MarketplaceCommissionField({ affiliateId }) {
  const [pct, setPct] = useState("");
  const [saved, setSaved] = useState(null);
  const [min, setMin] = useState(20);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get(`/organizations/${affiliateId}/marketplace-commission`)
      .then(({ data }) => { setPct(String(data.pct)); setSaved(data.pct); setMin(data.min_pct); })
      .catch(() => {});
  }, [affiliateId]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch(`/organizations/${affiliateId}/marketplace-commission`, { pct: Number(pct) });
      setSaved(data.pct);
      setPct(String(data.pct));
      toast.success(`Marketplace commission set to ${data.pct}%`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mb-6 border-t-2 border-black pt-5" data-testid="marketplace-commission-section">
      <div className="flex items-center gap-2 mb-1">
        <Percent size={14} weight="bold" />
        <div className="font-chivo font-black uppercase tracking-tight">Marketplace commission</div>
      </div>
      <p className="text-xs text-zinc-600 mb-2">
        Share of the sale price this affiliate earns when one of their leads sells in the marketplace. Minimum {min}%.
      </p>
      <div className="flex items-center gap-2">
        <input type="number" min={min} max={100} step={0.5} value={pct} onChange={(e) => setPct(e.target.value)}
               className="border-2 border-black px-2 py-1 w-24 text-sm" data-testid="marketplace-commission-input" />
        <span className="text-sm font-bold">%</span>
        <button type="button" onClick={save} disabled={saving || pct === "" || Number(pct) === saved}
                className="border-2 border-black bg-black text-white px-3 py-1 text-[11px] uppercase tracking-widest disabled:opacity-40"
                data-testid="marketplace-commission-save">
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
